// pages/CongTrinhThietKe/BietThu/index.tsx
import { useState } from 'react'
import { PageHero, ProjectGrid, CtaSection, Pagination } from '../../../components'
import { useProjects } from '../../../features/projects/hooks/useProjects'
import { bietThuProjects } from '../../../data/bietThuProjects'
import useDocumentTitle from '../../../hooks/useDocumentTitle'
import './BietThu.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Công trình thiết kế', path: '/cong-trinh-thiet-ke' },
  { label: 'Biệt thự' },
]

const BietThuPage = () => {
  useDocumentTitle('Thiết Kế Biệt Thự - MAXCONST')
  
  useState(() => {
    try {
      sessionStorage.setItem('lastVisitedList', '/biet-thu')
      sessionStorage.setItem('lastVisitedListName', 'Biệt thự')
    } catch (e) {
      // ignore
    }
  })

  const {
    currentProjects,
    loading,
    error,
    currentPage,
    totalPages,
    totalCount,
    startIndex,
    endIndex,
    setCurrentPage,
    goToNextPage,
    goToPrevPage,
    getPageNumbers,
  } = useProjects({
    category: 'biet-thu',
    pages: 10,
  })

  return (
    <div className="biet-thu-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Đẳng Cấp"
        title="Thiết Kế Biệt Thự"
        titleHighlight="Biệt Thự"
        description="Chiêm ngưỡng các mẫu thiết kế biệt thự vườn, biệt thự tân cổ điển, biệt thự hiện đại sang trọng và đẳng cấp bậc nhất"
        breadcrumbs={BREADCRUMBS}
        stats={
          totalCount > 0
            ? [
                { number: `${totalCount}+`, label: 'Mẫu thiết kế' },
                { number: '10+', label: 'Năm kinh nghiệm' },
                { number: '100%', label: 'Cam kết chất lượng' },
              ]
            : undefined
        }
      />

      {/* Content */}
      <div className="container section">
        {/* Projects Grid */}
        <ProjectGrid
          projects={currentProjects}
          loading={loading}
          error={error}
        />

        {/* Pagination */}
        {!loading && !error && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            startIndex={startIndex}
            endIndex={endIndex}
            getPageNumbers={getPageNumbers}
            onPageChange={setCurrentPage}
            onPrev={goToPrevPage}
            onNext={goToNextPage}
          />
        )}

        {/* CTA */}
        <CtaSection
          title="Bạn Muốn Sở Hữu Một Căn Biệt Thự Sang Trọng?"
          titleHighlight="Biệt Thự"
          description="Liên hệ ngay với đội ngũ kiến trúc sư Maxconst để bắt đầu hiện thực hóa ngôi nhà mơ ước của bạn"
        />
      </div>
    </div>
  )
}

export default BietThuPage
